import cn from "classnames";
import { type RefObject, useRef } from "react";
import { useCountUp } from "react-countup";
import TextField from "@/components/site-builder/TextField";
import { getTextAlignmentClassName } from "@/utils/style/getTextAlignmentClassName";
import type { StatisticsBlock } from "../../types";
import type { SiteBuilderModuleTextField } from "@/types/site-builder";
import { getNumberSeparator } from "../../utils";
import s from "./AnimatedStatistic.module.scss";

interface AnimatedStatisticProps {
  block: StatisticsBlock;
}

export default function AnimatedStatistic(props: AnimatedStatisticProps) {
  const {
    block: { statistic, prefix, suffix, countUpFrom, format },
  } = props;
  const countUpRef = useRef<HTMLDivElement>(null);
  useCountUp({
    ref: countUpRef as RefObject<HTMLDivElement>,
    start: +countUpFrom,
    end: +statistic.text!,
    separator: getNumberSeparator(format),
  });

  const prefixField: SiteBuilderModuleTextField = {
    ...statistic,
    text: prefix,
  };
  const suffixField: SiteBuilderModuleTextField = {
    ...statistic,
    text: suffix,
  };

  const className = cn(
    s.wrapper,
    getTextAlignmentClassName(statistic.alignment),
  );

  return (
    <div className={className}>
      <TextField type="header-h2" field={prefixField} />
      <TextField type="header-h2" field={statistic} ref={countUpRef} />
      <TextField type="header-h2" field={suffixField} />
    </div>
  );
}
